<div class="page">
  <div class="page-header">
    <div>
      <h1>{{ 'STUDENTS.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'STUDENTS.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="printListPdf()"
        [disabled]="exporting || !selectedClassId || (!selected.length && !filteredItems.length)"
        [attr.title]="!selectedClassId ? ('STUDENTS.PDF_SELECT_CLASS' | translate) : null"
      >
        <mat-icon>table_view</mat-icon>
        {{ (exportingList ? 'STUDENTS.LIST_PDF_EXPORTING' : 'STUDENTS.PRINT_LIST') | translate }}
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="printCardsPdf()"
        [disabled]="exporting || !selectedClassId || (!selected.length && !filteredItems.length)"
        [attr.title]="!selectedClassId ? ('STUDENTS.PDF_SELECT_CLASS' | translate) : null"
      >
        <mat-icon>badge</mat-icon>
        {{ (exportingCards ? 'STUDENTS.PDF_EXPORTING' : 'STUDENTS.PRINT_CARDS') | translate }}
      </button>
      <button type="button" class="btn btn-primary" *appAccess="'students:add'" (click)="onAdd()" [disabled]="exporting">
        <mat-icon>add</mat-icon>
        {{ 'STUDENTS.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>

  <div class="card">
    <div class="table-toolbar">
      <div class="table-toolbar-left">
        <input
          type="search"
          class="search-input"
          [placeholder]="'STUDENTS.SEARCH' | translate"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
        />
        <div class="class-filter">
          <app-searchable-select
            [(ngModel)]="selectedClassId"
            [options]="classOptions"
            [placeholder]="allClassesLabel"
            [emptyLabel]="allClassesLabel"
            [searchPlaceholder]="searchPlaceholder"
            [allowEmpty]="true"
            (selectionChange)="onClassChange()"
          ></app-searchable-select>
        </div>
        <span class="selection-badge" *ngIf="selected.length">
          {{ selected.length }} {{ 'COMMON.SELECTED' | translate }}
        </span>
      </div>
      <div class="table-toolbar-right">
        <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length" (click)="clearSelection()">
          {{ 'COMMON.CLEAR' | translate }}
        </button>
        <ng-container *appAccess="'students:edit'">
          <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length === 1" (click)="onEdit()">
            {{ 'COMMON.EDIT' | translate }}
          </button>
        </ng-container>
        <ng-container *appAccess="'students:delete'">
          <button type="button" class="btn btn-danger btn-sm" *ngIf="selected.length" (click)="onDeleteMany()">
            {{ 'COMMON.DELETE' | translate }}
          </button>
        </ng-container>
      </div>
    </div>

    <div class="table-scroll">
      <table class="data-table" *ngIf="paginatedItems.length; else emptyStudents">
        <thead>
          <tr>
            <th style="width: 44px;"></th>
            <th>{{ 'STUDENTS.NAME' | translate }}</th>
            <th>{{ 'STUDENTS.CODE' | translate }}</th>
            <th>{{ 'STUDENTS.CLASS' | translate }}</th>
            <th>{{ 'STUDENTS.STATUS' | translate }}</th>
            <th>{{ 'STUDENTS.BUS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of paginatedItems"
            class="clickable"
            [class.selected]="isSelected(item)"
            (click)="openDetails(item)"
          >
            <td (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="isSelected(item)" (change)="toggleSelection(item, $event)" />
            </td>
            <td>{{ displayName(item) }}</td>
            <td>{{ item.studentCode || '—' }}</td>
            <td>{{ item.class?.name || '—' }}</td>
            <td>{{ statusKey(item.status) | translate }}</td>
            <td>{{ item.bus?.number || item.bus?.name || '—' }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyStudents>
        <div class="empty-state">{{ 'STUDENTS.EMPTY' | translate }}</div>
      </ng-template>
    </div>

    <div class="table-footer">
      <div class="paginator">
        <span>{{ 'COMMON.ROWS_PER_PAGE' | translate }}</span>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
        </select>
        <span>{{ pageStart }}–{{ pageEnd }} {{ 'COMMON.OF' | translate }} {{ filteredItems.length }}</span>
      </div>
      <div class="page-actions">
        <button type="button" class="btn btn-secondary btn-sm" (click)="previousPage()" [disabled]="pageIndex === 0">
          {{ 'COMMON.PREVIOUS' | translate }}
        </button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">
          {{ 'COMMON.NEXT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showDeleteModal">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header"><h3>{{ 'COMMON.CONFIRM_DELETE' | translate }}</h3></div>
    <div class="modal-body"><p>{{ deleteModalBody | translate: deleteModalParams }}</p></div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onDeleteConfirm(false)">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-danger" (click)="onDeleteConfirm(true)">
        {{ 'COMMON.DELETE' | translate }}
      </button>
    </div>
  </div>
</div>
